export const blankVehicleCount = {
  bikes: 0,
  buses: 0,
  cars: 0,
  people: 0,
  trucks: 0,
  unknown: 0,
}
